import { Button, styled } from '@mui/material';

export const StyledSubmitAndCopyBtn = styled(Button)`
  height: 50px;
  padding: 13px 24px;
  width: 185px !important;
  font-size: 16px;
  line-height: 24px;
  min-width: 185px;
  font-weight: 500;
  order: 3;

  &:disabled {
    color: #fff;
    background-color: #a0bcc6;
    padding: 13px 24px;
  }
`;
